import React, { Component } from "react";
import PropTypes from "prop-types";
import { Route } from 'react-router';
import { connect } from "react-redux";
import { siteDetailsInitOperation } from 'sites/state/modules/common/operations';
import {
   isSiteInitedSelector,
   authUserSelector,
   isLouisianaBlockedSelector,
   siteInfoSelector,
   isFetchingLogoutSelector,
   isGlobalLoadingSelector,
} from 'sites/state/modules/common/selectors';
import StateBlock from 'sites/views/block/state';
import PageLoader from "common/components/modules/page-loading";
import LayoutView from "./layout-view";

class SimpleMixed extends Component {
   static propTypes = {
      authUser: PropTypes.object,
      isSiteInited: PropTypes.bool.isRequired,
      component: PropTypes.any,
      init: PropTypes.func.isRequired,
      pushEnableStatus: PropTypes.string,
      isLouisianaBlocked: PropTypes.bool,
      siteInfo: PropTypes.object,
      isFetchingLogout: PropTypes.bool,
      needToInit: PropTypes.bool,
      isGlobalLoading: PropTypes.bool,
   };

   componentDidMount() {
      const {
         init,
         isSiteInited,
         needToInit,
      } = this.props;
      if(needToInit && !isSiteInited){
         init();
      }
   }

   render() {
      const {
         component: ChildComponent,
         isSiteInited,
         isLouisianaBlocked,
         siteInfo,
         isFetchingLogout,
         needToInit,
         isGlobalLoading,
         ...rest
      } = this.props;
      if(isLouisianaBlocked){
         return (
            <StateBlock
               state='Louisiana'
               logo={ siteInfo.site_logo }
            />
         )
      }

      if(isFetchingLogout) {
         return (
            <PageLoader withLoader loaderColor='primary' />
         )
      }

      return (
         <LayoutView
            isSiteInited={ isSiteInited }
            isGlobalLoading={ isGlobalLoading }
            noNeedToInit={ !needToInit }
            isHideMenu
            isHideHeader
         >
            <Route
               { ...rest }
               render={ (matchProps) => {
                  return <ChildComponent { ...matchProps } />;
               } }
            />
         </LayoutView>
      )
   }
}

const mapStateToProps = (state) => {
   return {
      authUser: authUserSelector(state),
      siteInfo: siteInfoSelector(state),
      isSiteInited: isSiteInitedSelector(state),
      isLouisianaBlocked: isLouisianaBlockedSelector(state),
      isFetchingLogout: isFetchingLogoutSelector(state),
      isGlobalLoading: isGlobalLoadingSelector(state),
   };
}

const mapDispatchToProps = (dispatch) => ({
   init: () => {
      dispatch(siteDetailsInitOperation())
   },
});

export default connect(mapStateToProps, mapDispatchToProps)(SimpleMixed);
